import React from 'react';
import styles from './NoData.module.scss';

const NoData = ({ message = 'No Data Found', minHeight = 470 }) => {
  return (
    <div className={styles['no-data']} style={{ minHeight }}>
      {message}
    </div>
  );
};

export default NoData;
